import { Star } from "lucide-react";

export function StarRating({ value = 0, size = 14, className = "" }) {
  const full = Math.round(value);
  return (
    <span className={`inline-flex items-center gap-0.5 ${className}`} data-testid="star-rating">
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          size={size}
          className={i <= full ? "fill-amber-400 text-amber-400" : "text-slate-300"}
        />
      ))}
    </span>
  );
}

export function StarInput({ value, onChange, size = 30 }) {
  return (
    <div className="inline-flex items-center gap-1.5" data-testid="star-input">
      {[1, 2, 3, 4, 5].map((i) => (
        <button
          key={i}
          type="button"
          data-testid={`star-input-${i}`}
          onClick={() => onChange(i)}
          className="transition-transform hover:scale-110 focus:outline-none"
        >
          <Star
            size={size}
            className={i <= value ? "fill-amber-400 text-amber-400" : "text-slate-300 hover:text-amber-300"}
          />
        </button>
      ))}
    </div>
  );
}
